module.exports = __webpack_public_path__ + "img/slideshow-quatrieme-couverture-lmds.04320c0f.png";